import * as React from "react";

import Totals from "./totals";
import {useContext, useState, useEffect} from "react";
import {Basket} from "../../../context/basket";
import { useRouter } from 'next/navigation';
import Grid from '@mui/material/Unstable_Grid2';
import Checkout from "../../model/elements/checkout";
import Referral from '../../model/elements/referral';
import Box from '@mui/material/Box';
import Coupon from '../../../checkout/components/summary/coupon';
import ChevronIcon from "../../../layout/icons/chevron";
import Image from "next/image";
import removeFromBasket from "./actions/remove";

const Summary = (props) =>
{
    const basket = useContext(Basket);
    const pathing = (props.path !== 'undefined') ? props.path : false;
    const [showDiscountField, setShowDiscountField] = useState(false);
    const { push } = useRouter();
    // Added for the collapsible coupon section
    const [isCouponSectionCollapsed, setIsCouponSectionCollapsed] = useState(true);

    // Toggle the visibility of the coupon section
    const toggleCouponSection = () => {
        setIsCouponSectionCollapsed(!isCouponSectionCollapsed);
    };

    const editOrder = () => {
        push('/customiser');
    }

    const defaultDiscountOpen = () => {
        if (basket?.data?.quote?.quote?.discount_codes !== null) {
            try {
                const activeCodes = JSON.parse(basket?.data?.quote?.quote?.discount_codes);
                if (activeCodes.length > 0) {
                    setIsCouponSectionCollapsed(false);
                    return true;
                }
            } catch (e) {}
        }

        return false;
    }

    const getProductNameWithoutDuration = (name) => {
        const durationRegex = / - \d+ month(s)?$/;
        return name.replace(durationRegex, "");
    }

    const removeItem = (id, parentProductId) => {
        props.setLoadingMessage('Removing item from basket...');
        props.setLoader(true);
        removeFromBasket(id, parentProductId).then(() => {
            basket.updateBasketReturn().then(function (res) {
                props.setLoader(false);
            });
        });
    }

    let simpleProducts = [];
    let planProduct = [];
    let componentProductData = [];

    // Split up the basket into constituent types.
    basket?.data?.quote?.quote?.items?.map((item) => {
        if (item.is_component) {
            componentProductData.push(item);
        } else if (item.is_frequency && item.route !== 'free-gift') {
            planProduct.push(item);
        } else if (item.is_simple || item.route === 'free-gift') {
            simpleProducts.push(item);
        }
    });

    let productNameWithoutDuration = '';
    if (planProduct.length > 0) {
        // Regular expression to find and remove duration part like " - 6 month(s)"
        const durationRegex = / - \d+ month(s)?$/;
        productNameWithoutDuration = planProduct[0].product_name.replace(durationRegex, "");
    }

    if (planProduct.length === 0 && componentProductData.length === 0 && simpleProducts.length === 0) {
        return <Grid className="summary-wrapper bg-transparent empty-basket">
            <Box className="no-products-notice" style={{fontSize: '1.2rem'}}>
                There are no products in your basket.
            </Box>
            <Box className="marketing" style={{marginTop: '20px'}}>
                <div className="checkout-button-wrapper">
                    <button
                        color="primary"
                        className="button"
                        style={{maxWidth: '300px'}}
                        title="Continue shopping"
                        onClick={() => {window.location.href = 'https://sons.co.uk/pages/hair-loss'}}>
                        <span className="checkout-button-text">Continue shopping</span>
                    </button>
                </div>
            </Box>
        </Grid>
    }

    useEffect(() => {
        defaultDiscountOpen();
    }, [basket?.data?.quote]);

    return ((planProduct.length > 0 && basket?.data && componentProductData.length > 0) || (basket?.data && planProduct.length === 0 && simpleProducts.length > 0)) && (
        <Grid container className="summary-wrapper">
                <Grid xs={12} lg={8} className="padding-right-2 padding-tablet-right-0 padding-tablet-bottom-2">
                    <Box>
                        <Grid container className="align-baseline">
                            <Grid xs={8}>
                                <h2 className="h1 no-margin">Basket</h2>
                            </Grid>
                            <Grid xs={4} className="flex-end hide">
                                <a onClick={() => editOrder()} className="edit-order primary">
                                    <span>Edit</span>
                                </a>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box className="cart-contents">
                        {planProduct.length > 0 && componentProductData.length > 0 && (
                            <Box className="plan-item" md={12} lg={12} key={planProduct[0].id}>
                                {productNameWithoutDuration && (
                                    <>
                                        <h3 className="margin-bottom-0">Plan: <span
                                            className="font-weight-300">{productNameWithoutDuration}</span></h3>
                                        <div className="item-actions">
                                            <a
                                                onClick={() => removeItem(planProduct[0].quote_item_id, planProduct[0].parent_id)}
                                                id={'remove-item-' + planProduct[0].id}
                                                title={'Remove ' + planProduct[0].parent_name}
                                            >Remove</a>
                                        </div>
                                    </>
                                )}
                            </Box>
                        )}

                        <div className="your-plan-components">
                            {planProduct.length > 0 && componentProductData.length > 0 && (
                                <h3 className="margin-bottom">Included in your subscription plan:</h3>
                            )}
                        </div>
                        {componentProductData.map((item) => (
                            <Grid container className="align-baseline bg-off-white rounded padding-1"
                                  key={'component-product-wrapper-' + item.product_id}>
                                <Grid xs={4} md={2} lg={2}>
                                    <Box style={{position: 'relative', width: '100%', height: '100%'}}>
                                        <Image
                                            src={item.images[0]?.url_file}
                                            alt={item.product_name}
                                            height={item.images[0]?.height}
                                            width={item.images[0]?.width}
                                            sizes="100vw"
                                            quality={95}
                                            priority={true}
                                        />
                                    </Box>
                                </Grid>
                                <Grid className="product-name" xs={6} key={'component-' + item.product_id}>
                                    <h3>Name: {item.product_name}</h3>
                                    <h3>Frequency: {planProduct[0].month_data}</h3>
                                </Grid>
                                <Grid xs={4} className="flex-end">

                                </Grid>
                            </Grid>
                        ))}
                        {planProduct.length > 1 && (
                            <div className="your-plan-components">
                                <h3 className="margin-bottom">Other plans in your basket:</h3>
                            </div>
                        )}
                        {planProduct.length > 1 && planProduct.map((item) => {
                            if (planProduct[0].sku === item.sku) {
                                return false;
                            }
                            return (
                                <>
                                    <Grid container className="align-baseline bg-off-white rounded padding-1 other-plans"
                                          key={'component-product-wrapper-' + item.product_id}>
                                        <Grid xs={4} md={2} lg={2}>
                                            <Box style={{position: 'relative', width: '100%', height: '100%'}}>
                                                <Image
                                                    src={item.images[0]?.url_file}
                                                    alt={item.product_name}
                                                    height={item.images[0]?.height}
                                                    width={item.images[0]?.width}
                                                    sizes="100vw"
                                                    quality={90}
                                                    priority={true}
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid className="product-name" xs={6} key={'component-' + item.product_id}>
                                            <h3>Name: {getProductNameWithoutDuration(item.product_name)}</h3>
                                            <h3>Frequency: {item.month_data}</h3>
                                            <h3>Price: + {basket.data.quote.store.currency.symbol}{item.price} every {item.month_data}</h3>
                                        </Grid>
                                        <Grid xs={4} className="flex-end">
                                            <div className="item-actions">
                                                <a
                                                    onClick={() => removeItem(item.quote_item_id, null)}
                                                    id={'remove-item-' + item.quote_item_id}
                                                    title={'Remove ' + item.product_name}
                                                >Remove</a>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </>
                            )
                        })}
                        {simpleProducts.length > 0 && (
                            <div className="your-one-off-items">
                                <h3>One off purchase:</h3>
                            </div>
                        )}
                        {simpleProducts.length > 0 && simpleProducts.map((item) => (
                            <>
                                <Grid container className="align-baseline bg-off-white rounded padding-1 one-off"
                                      key={'component-product-wrapper-' + item.product_id}>
                                    <Grid xs={4} md={2} lg={2}>
                                        <Box style={{position: 'relative', width: '100%', height: '100%'}}>
                                            <Image
                                                src={item.images[0]?.url_file}
                                                alt={item.product_name}
                                                height={item.images[0]?.height}
                                                width={item.images[0]?.width}
                                                sizes="100vw"
                                                quality={90}
                                                priority={true}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid className="product-name" xs={6} key={'component-' + item.product_id}>
                                        <h3>Name: {getProductNameWithoutDuration(item.product_name)}</h3>
                                        {item.route === 'free-gift' && item.original_price !== null && (
                                            <h3>Included <strong><u>FREE</u></strong> with your order.
                                                Usually:&nbsp;
                                                <strike>
                                                    <span>
                                                        {basket.data.quote.store.currency.symbol}
                                                        {item.original_price.toFixed(2)}
                                                    </span>
                                                </strike>
                                            </h3>
                                        )}
                                        {item.route !== 'free-gift' && (
                                            <h3>Price: {basket.data.quote.store.currency.symbol}{item.price}</h3>
                                        )}
                                    </Grid>
                                    <Grid xs={4} className="flex-end">
                                        <div className="item-actions">
                                            {item.route !== 'free-gift' && (
                                                <a
                                                    onClick={() => removeItem(item.quote_item_id, null)}
                                                    id={'remove-item-' + item.quote_item_id}
                                                    title={'Remove ' + item.product_name}
                                                >Remove</a>
                                            )}
                                        </div>
                                    </Grid>
                                </Grid>
                            </>
                        ))}
                    </Box>
                    <Grid className="basket-discount bg-secondary rounded padding-2 margin-top-2" xs={12}>
                        <Box>
                            <Grid container>
                            <Grid xs={8}>
                                    <h2 className="no-margin" onClick={toggleCouponSection}>{isCouponSectionCollapsed ? 'Got a discount code?' : 'Your discount'}</h2>
                                </Grid>
                                <Grid xs={4} className="flex-end">
                                    <Box>
                                        <ChevronIcon onClick={toggleCouponSection} width="24" height="20" className={`chevron-icon ${isCouponSectionCollapsed ? 'rotate-0' : 'rotate-180'} opacity-2`}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        {!isCouponSectionCollapsed && (
                            <Coupon
                            loader={props.loader}
                            setLoader={props.setLoader}
                            setShowDiscountField={setShowDiscountField}
                            setLoadingMessage={props.setLoadingMessage}
                            path={props.path}
                            />
                        )}
                    </Grid>
                </Grid>
            <Grid className="bg-white rounded padding-2" xs={12} lg={4}>
                <Totals
                    basketData={basket?.data}
                        loader={props.loader}
                        setLoader={props.setLoader}
                    />
                    <Referral />
                    <Checkout
                        loader={props.loader}
                        setLoader={props.setLoader}
                        setLoadingMessage={props.setLoadingMessage}
                        key={'checkout-button'}
                    />
                </Grid>
        </Grid>
    )
}

export default Summary;